// @flow

import api from '../../lib/api';

import { camelizeKeys } from 'humps';

export default async function verifyPromocode(promocode: string, invoice_id: string) {
  try {
    const { data } = await api.postWithoutToken('payments/promocode/verify', { invoice_id, promocode: promocode.trim() });
    return camelizeKeys(data);
  } catch (err) {
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/services/cart/verifyPromocode.js